import { FormGroup } from '@angular/forms';
import { AddressDetails } from '@app/api/dmc';

/**
 * Patches an address form group with data from the backend address proxy.
 *
 * The backend normalises the address provider response, so this only needs a
 * single flat mapping rather than branching on provider specific shapes.
 *
 * @param formGroup The form group to patch (can be nested, e.g. form.get('address'))
 * @param addressData The normalised address data returned by the API
 * @param formFieldPath Optional path to the address form group if it's nested within another form group
 * @returns void
 */
export function patchAddress(
  formGroup: FormGroup | null,
  addressData: AddressDetails | null | undefined,
  formFieldPath?: string
): void {
  if (!formGroup || !addressData) return;

  const targetGroup = formFieldPath ? formGroup.get(formFieldPath) as FormGroup : formGroup;

  if (!targetGroup) return;

  targetGroup.patchValue({
    id: addressData.id,
    streetName: addressData.streetName,
    streetCode: addressData.streetCode,
    buildingNumber: addressData.buildingNumber,
    floorIdentification: addressData.floorIdentification,
    roomIdentification: addressData.roomIdentification,
    subDivisionName: addressData.subDivisionName,
    postalCode: addressData.postalCode,
    cityName: addressData.cityName,
    municipalityCode: addressData.municipalityCode,
    darReference: addressData.id,
    country: 'DK'
  });
}
